import {SpinnerService} from "../../modules/SpinnerModule";
import {DataHubService} from "../../modules/DataHubModule";

export function UnlinkedProfileController($dataHub: DataHubService, $spinner: SpinnerService) {
    var vm = this;

    vm.profiles = [];
    $spinner.show('Starting');
    $dataHub.client.onCustomerProfileUpdated(e => vm.profiles.merge(e, x=>x.guid));
    $dataHub.client.onCustomerProfileRemoved(e => vm.profiles.remove(e, x=>x.guid));

    vm.refresh = () => {
        $spinner.show('Loading');
        $dataHub.server.paymentUnlinkedProfileSub()
            .catch(handleError)
            .finally(() => $spinner.hide());
    };

    $dataHub.onConnected(vm.refresh);

    function handleError(e) {
        console.error(e);
        if (e.data && e.data.exceptionMessage) {
            vm.error = e.data.exceptionMessage;
        } else {
            vm.error = e;
        }
    }

    vm.save = function (profile) {
        $spinner.show('Saving');
        $dataHub.server.paymentLinkCustomerProfile(profile)
            .catch(handleError)
            .finally(() => $spinner.hide());
    }

}
